import { withTranslation } from "next-i18next";
import classNames from "classnames";
import AutonomousLinks from "./AutonomousLinks";
import LeClosetLinks from "./LeClosetLinks";
import LgdLinks from "./LgdLinks";
import FooterLegal from "./FooterLegal";
import FooterReferral from "./FooterReferral";
import LanguageSelector from "@components/core/LanguageSelector";

const Footer = ({ className, t }) => {
  const displayLinks = () => {
    if (process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER === "true") return <AutonomousLinks />;

    switch (process.env.NEXT_PUBLIC_CUSTOMER) {
      case "lecloset":
        return <LeClosetLinks />;
      case "lgd":
        return <LgdLinks />;
      default:
        return null;
    }
  };

  const displayUtilities = () => <div className="px-3 px-md-4 px-lg-0">{displayLinks()}</div>;

  const displayLegals = () => {
    if (process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER === "true") return null;

    return <FooterLegal />;
  };

  const displayBrand = () => (
    <p className="mt-2 mb-0 font-size-sm text-primary text-center">
      &copy;&nbsp;
      {new Date().getFullYear()}
      &nbsp;
      {t("common:footer.copyright")}
    </p>
  );

  return (
    <footer className={classNames("border-top border-light pt-4", className)}>
      <div className="d-lg-none">
        {displayUtilities()}
        <div className="px-3 px-md-4 py-4 d-lg-none">
          <FooterReferral />
        </div>
      </div>

      <div className="d-none d-lg-flex footer-container flex-column px-0">
        <div className="w-100 d-flex">
          <div className="col-0 col-lg-8 px-0">{displayUtilities()}</div>
          <div className="col-12 col-lg-4 px-0 pt-4">
            <FooterReferral />
          </div>
        </div>
      </div>

      <LanguageSelector />

      <div className="d-flex flex-column align-items-center justify-content-center mt-4 py-2 bg-white">
        {displayLegals()}
        {displayBrand()}
      </div>
    </footer>
  );
};

export default withTranslation("common")(Footer);
